import script from "./ServicesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&setup=true&lang=js"

import "./ServicesComponent.vue?vue&type=style&index=0&id=6b8eb3a2&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8eb3a2"]])

export default __exports__